import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPaywall3Chevron = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.293 7.294a1 1 0 0 1 1.414 0l3.47 3.47a1.75 1.75 0 0 1 0 2.474l-3.47 3.47a1 1 0 0 1-1.414-1.414L12.586 12 9.293 8.708a1 1 0 0 1 0-1.414"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPaywall3Chevron;
